const fillConfirmedUpdatedTypesList = Object.freeze({
  Fill: 'Fill',
  Confirmed: 'Confirmed',
  Updated: 'Updated',
});

export { fillConfirmedUpdatedTypesList };
